<template>
  <div>
    <el-dialog :visible.sync="show" width="800" :before-close="handleClose" @open="openEvt">
      <div class="center">
        <div class="top">
          <el-input v-model="queryData.keyWord" placeholder="请输入层级名称或层级编号（例如查询某三级分类 输入格式为01 02 03)"
            style="width: 60%"></el-input>
          <div class="selectBtnBox">
            <el-button size="small" type="primary" @click="queryEvt">查询</el-button>
            <el-button size="small" type="primary" @click="resettingEvt">重置</el-button>
          </div>
        </div>
        <div class="Radio">
          <el-radio v-model="queryData.type" @change="queryEvt" label="1">层级代码</el-radio>
          <el-radio v-model="queryData.type" @change="queryEvt" label="0">管理类别</el-radio>
        </div>

        <div class="tableBox">
          <!-- is-indeterminate -->
          <el-table ref="multipleTable" :data="tableData" style="width:800px;margin-bottom: 20px;" v-loading="loading"
            height="500" :how-overflow-tooltip="true" row-key="id" border lazy :tree-props="{ children: 'children' }">
            <el-table-column type="show" class-name="selection" width="40">
              <template slot-scope="scope">
                <el-checkbox :indeterminate="scope.row.isIndeterminate" @change="selectionEvt(scope.row)"
                  v-model="scope.row.show"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="queryData.type == 0 ? '管理类别' : '层级'" width="">
            </el-table-column>
            <el-table-column v-if="queryData.type == 1" prop="categoryName" label="管理类别" width="200">
            </el-table-column>
            <el-table-column prop="versionName" label="版本" width="100">
            </el-table-column>
          </el-table>
          <!--  -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitEvt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetProductionRangeTree
} from '@/api'
export default {
  props: ['show', "addSpecifications", 'tags'],
  name: 'producePopup',
  data() {
    return {
      selectInput: '',
      SelectRadio: '1',
      loading: true,
      tableData: [],
      queryData: {
        keyWord: '',
        type: '1'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      GetProductionRangeTree(this.queryData).then(res => {
        this.$nextTick(() => {
          this.tableData = res.returnData.data
          this.openEvt()
          this.loading = false
        });
      })
    },
    openEvt() {
      if (this.$props.tags.length == 0) {
        this.tableData = this.tableData.map(res => {
          res.show = false
          res.isIndeterminate = false
          res.children.forEach(val => {
            val.show = false
            val.isIndeterminate = false
            val.children.forEach(k => {
              k.show = false
            })
          })
          return res
        })
      } else {
        this.$props.tags.forEach(res => {
          this.showSelection(res.id)
        })
      }
    },
    showSelection(id) {
      this.tableData = this.tableData.map(res => {
        if (res.id == id) {
          res.show = true
        }
        if (res.children.length != 0) {
          res.children.forEach(val => {
            if (val.id == id) {
              res.isIndeterminate = true
              val.show = true
            }
            if (val.children.length != 0) {
              val.children.forEach(k => {
                if (k.id == id) {
                  val.isIndeterminate = true
                  k.show = true
                }
                if (k.children.length != 0) {
                  k.children.forEach(v => {
                    if (v.id == id) {
                      k.isIndeterminate = true
                      v.show = true
                    }
                  })
                }
              })
            }
          })
        }
        return res
      })
    },
    queryEvt() {
      this.loading = true
      this.getList()
    },
    resettingEvt() {
      this.queryData.keyWord = ''
      this.loading = true
      this.getList()
    },
    selectionEvt(val) {
      let arr = []
      if (val.children.length !== 0) {
        arr = this.tableData.map(res => {

          if (res.id == val.id) {
            // res.show = true
            res.isIndeterminate = false
            if (res.show == false) {
              res.children.forEach(e => {
                e.show = false
                e.isIndeterminate = false
                if (e.children.length !== 0) {
                  e.children.forEach(k => {
                    k.show = false
                  })
                }
              })
            } else {
              res.children.forEach(e => {
                e.show = true
                if (e.children.length !== 0) {
                  e.children.forEach(k => {
                    k.show = true
                  })
                }
              })
            }
          }
          if (this.queryData.type == '0') {
            res.children.forEach(e => {
              if (e.id == val.id) {
                e.isIndeterminate = false
                if (e.show == false) {
                  e.children.forEach(k => {
                    k.show = false
                    e.isIndeterminate = false
                    if (k.children.length !== 0) {
                      e.children.forEach(j => {
                        j.show = false
                      })
                    }
                  })
                } else {
                  res.children.forEach(e => {
                    if (e.children.length !== 0) {
                      e.children.forEach(k => {
                        k.show = true
                        k.children.forEach(j => {
                          j.show = true
                        })
                      })
                    }
                  })



                }
              }
            })
          }
          return res
        })
      } else {
        arr = this.tableData.map(res => {
          if (res.id == val.parentId) {
            res.isIndeterminate = true
            if (res.id == val.id) {
              res.show = !res.show
            }
          }
          res.children.forEach(e => {
            if (e.id == val.parentId) {
              e.isIndeterminate = true
              res.isIndeterminate = true
              if (e.id == val.id) {
                e.show = !e.show
              }
            }
          })
          return res
        })
      }
      this.$nextTick(() => {
        this.tableData = arr
      });
    },
    handleClose() {
      this.$emit('closeProduce')
    },
    submitEvt() {
      let arr = []
      if (this.queryData.type == '0') {
        this.tableData.forEach(res => {
          res.children.forEach(e => {
            if (e.show == true && !e.isIndeterminate) {
              arr.push({ name: e.name, id: e.id })
            }
            if (e.children.length != 0) {
              e.children.forEach(k => {
                if (k.show == true && !k.isIndeterminate) {
                  arr.push({ name: k.name, id: k.id })
                }
                if (k.children.length != 0) {
                  k.children.forEach(j => {
                    if (j.show == true && !j.isIndeterminate) {
                      arr.push({ name: j.name, id: j.id })
                    }
                  })
                }
              })
            }
          })
        })
      } else {
        this.tableData.forEach(res => {
          if (res.children.length !== 0) {
            res.children.forEach(e => {
              if (e.show == true && !e.isIndeterminate) {
                arr.push({ name: e.name, id: e.id })
              }
              if (e.children != 0) {
                e.children.forEach(k => {
                  if (k.show == true && !k.isIndeterminate) {
                    arr.push({
                      name: k.name,
                      id: k.id
                    })
                  }

                })
              }
            })
          } else {
            if (res.show == true) {
              arr.push({ name: res.name, id: res.id })
            }
          }
        })
      }

      this.$emit('selectedProduce', arr);
      this.$emit('closeProduce')
    },
  }
}

</script>
<style lang="scss" scoped>
.top {
  display: flex;

  .selectBtnBox {
    margin-left: 30px;

  }
}

.Radio {
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /deep/.el-radio__label {
    font-size: 14px;
  }
}

.Radio .el-radio:nth-child(1) {
  margin-left: 10px;
  margin-right: 12px;
}

.tableBox {
  display: flex;
  align-items: center;
}
</style>